import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import TaskApprovalStructure from "../../components/hygiene-system/task-approval/TaskApprovalStructure";

const HygineTaskApproval = () => {
  const userInfoData = useSelector(selectUser);

  return <TaskApprovalStructure userInfoData={userInfoData} />;
};

export default HygineTaskApproval;
